const AIStar = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`inline-block ${className}`}
      width="30"
      height="30"
      viewBox="0 0 20 20"
      fill="none"
    >
      <defs>
        <linearGradient
          id="guardian-gradient"
          x1="10"
          y1="2.5"
          x2="10"
          y2="17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#d99263" />
          <stop offset="10" stopColor="#f9d7b3" />
        </linearGradient>
      </defs>
      <path
        d="M10 2.5 L12.5 8.5 L18.5 10 L12.5 11.5 L10 17.5 L7.5 11.5 L1.5 10 L7.5 8.5 Z"
        fill="url(#guardian-gradient)"
        //   className="text-yellow-400"
      />
      <circle cx="15.5" cy="4.5" r="2" fill="#60a5fa" />
      <circle cx="5" cy="15" r="1.5" fill="#60a5fa" />
    </svg>
  );
};

AIStar.displayName = "AIStar";
export default AIStar;
